/*
 * CUSTOMIZATIONS:
 * - added parent prop to display parent site logo in subsite mobile menu.
 * - Use a default different logo for subsites
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { SiteProperty } from 'volto-site-settings';
import logo from './logo_white.png';
import logoSubsite from './logo_sottositi_2025.png';

const Logo = ({ parent, alt = 'Logo' }) => {
  const subsite = useSelector((state) => state.subsite?.data);

  let src = !subsite ? logo : logoSubsite;
  if (parent) {
    src = logo;
  }

  if (subsite && !subsite.subsite_logo) {
    return (
      <img
        src={logoSubsite}
        width={82}
        height={82}
        alt={alt}
        className="icon"
      />
    );
  }

  return (
    <SiteProperty
      property="site_logo"
      defaultValue={{ url: src, width: 82, height: 82 }}
      className="icon"
      alt={alt}
    />
  );
};

export default Logo;
